import {LinkPlugin as LexicalLinkPlugin} from '@lexical/react/LexicalLinkPlugin';

import {INTERNAL_URL_MATCHER, URL_MATCHER} from './AutoLinkPlugin';

export const LinkPlugin = () => {
  return (
    <LexicalLinkPlugin
      validateUrl={(url) => URL_MATCHER.test(url) || INTERNAL_URL_MATCHER.test(url)}
    />
  );
};
